import { useState } from "react";
import { PageTitle } from "../../layout/PageTitle";
import { createListStore } from "../../common/listStore";
import { renderListStore } from "../../common/listStoreUi";

export function TransactionCodeListPage() {
    const [useTransactionCodesStore] = useState(() => createListStore<TransactionCodeDto>({
        path: "settings/transactionCodes",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "code", label: "Code", width: 100 },
            { column: "description", label: "Name", width: 300 },
            { column: "isActive", label: "Active", width: 100 },
        ],
    }));

    return <>
        <PageTitle title="Transaction codes" />
        {renderListStore(useTransactionCodesStore, {
        })}
    </>;
}

interface TransactionCodeDto {
    id: number;
    code: string;
    description: string;
    isActive: boolean;
}
